import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { REASONS } from '../../common/constants';
import rain from '../../images/rain.svg';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import AirIcon from '@mui/icons-material/Air';
import WaterIcon from '@mui/icons-material/Water';

// 通告・通告テンプレートの作成で使用する「事由」
const ReasonButtons = (props) => {
  const { index, reasonCode } = props;
  const { typography } = useTheme();
  const styles = {
    chip: { ...typography.label14, height: '44px', padding: '0px 20px', borderRadius: '100px' },
    reasonChipIcon: { color: 'jiyuu' },
    headlineText: { ...typography.caption13bold, color: 'secondary.main' },
  };

  const handleClick = (value) => {
    props.handleChange({ reasonCode: value }, index);
  };

  return (
    <Stack spacing={1}>
      <FormLabel required sx={styles.headlineText}>事由</FormLabel>
      <Stack direction='row' spacing={1}>
        <Chip
          avatar={<Avatar src={rain} alt='雨' />}
          label={REASONS.RAIN.label}
          variant={reasonCode === REASONS.RAIN.value ? 'selected' : 'filled'}
          sx={styles.chip}
          onClick={() => {
            handleClick(REASONS.RAIN.value);
          }}
        />
        <Chip
          icon={<AirIcon sx={styles.reasonChipIcon} color='jiyuu' />}
          label={REASONS.WIND.label}
          variant={reasonCode === REASONS.WIND.value ? 'selected' : 'filled'}
          sx={styles.chip}
          onClick={() => {
            handleClick(REASONS.WIND.value);
          }}
        />
        <Chip
          icon={<WaterIcon sx={styles.reasonChipIcon} color='jiyuu' />}
          label={REASONS.FLOOD.label}
          variant={reasonCode === REASONS.FLOOD.value ? 'selected' : 'filled'}
          sx={styles.chip}
          onClick={() => {
            handleClick(REASONS.FLOOD.value);
          }}
        />
        <Chip
          label={REASONS.NULL.label}
          variant={reasonCode === REASONS.NULL.value ? 'selected' : 'filled'}
          sx={styles.chip}
          onClick={() => {
            handleClick(REASONS.NULL.value);
          }}
        />
      </Stack>
    </Stack>
  );
};

export default ReasonButtons;

ReasonButtons.propTypes = {
  index: PropTypes.number,
  reasonCode: PropTypes.number,
  handleChange: PropTypes.func,
};
